import axios from '@shared/axios-shared';

const getGalleryMedia = (params) => {
	return axios.get('/api/v2/gallery/media', { params });
};

const getAlbums = (params) => {
	return axios.get('/api/v2/albums', { params });
};

const getAlbum = (id) => {
	return axios.get(`/api/v2/albums/${id}`);
};

const createAlbum = (data) => {
	return axios.post('/api/v2/albums', data);
};

const updateAlbum = (id, data) => {
	return axios.put(`/api/v2/albums/${id}`, data);
};

const deleteAlbum = (id) => {
	return axios.delete(`/api/v2/albums/${id}`);
};

const addMediaToAlbum = (albumId, data) => {
	return axios.post(`/api/v2/albums/${albumId}/media`, data);
};

const removeMediaFromAlbum = (albumId, items) => {
	return axios.delete(`/api/v2/albums/${albumId}/media`, { data: { items } });
};

const startMediaDownload = (data) => {
	return axios.post('/api/v2/gallery/download', data);
};

const estimateMediaDownload = (data) => {
	return axios.post('/api/v2/gallery/download/estimate', data);
};

const getMediaDownloadStatus = (jobId) => {
	return axios.get(`/api/v2/gallery/download/${jobId}`);
};

export {
	getGalleryMedia,
	getAlbums,
	getAlbum,
	createAlbum,
	updateAlbum,
	deleteAlbum,
	addMediaToAlbum,
	removeMediaFromAlbum,
	startMediaDownload,
	estimateMediaDownload,
	getMediaDownloadStatus,
};
